import React from "react";
import { FaArrowLeft, FaEnvelope } from "react-icons/fa";
import styles from "../../../styles/components/profile/MessagesPanel.module.css";
import { formatSystemMessageDate } from "./messageUtils";

const SystemMessageThread = ({
  systemMessages,
  messagesListRef,
  onBack,
  onAction,
}) => (
  <div className={styles.messagesPanel}>
    <div className={styles.messagesHeader}>
      <button
        type="button"
        className={styles.backButton}
        onClick={onBack}
        aria-label="Back to conversations"
      >
        <FaArrowLeft />
      </button>
      <div className={styles.messagesHeaderUser}>
        <div
          className={`${styles.headerAvatarPlaceholder} ${styles.systemAvatar}`}
        >
          <img src="/logo192.png" alt="Simpary" />
        </div>
        <div>
          <div className={styles.headerNameRow}>
            <h3>System</h3>
          </div>
          <p className={styles.headerUsername}>Official updates from Simpary</p>
        </div>
      </div>
    </div>

    <div className={styles.messagesList} ref={messagesListRef}>
      {systemMessages.length === 0 ? (
        <div className={styles.emptyState}>
          <p>No system messages yet.</p>
        </div>
      ) : (
        systemMessages.map((delivery) => (
          <div
            key={delivery._id}
            id={`system-message-${delivery._id}`}
            className={`${styles.messageItem} ${styles.systemMessageItem}`}
          >
            <div className={styles.messageAvatar}>
              <FaEnvelope />
            </div>
            <div className={styles.messageContent}>
              <div className={styles.messageSender}>System</div>
              <div
                className={`${styles.messageBubble} ${styles.systemMessageBubble}`}
              >
                {delivery.systemMessage?.subject && (
                  <p className={styles.systemMessageSubject}>
                    {delivery.systemMessage.subject}
                  </p>
                )}
                <p>{delivery.systemMessage?.body || ""}</p>
                {delivery.systemMessage?.actionUrl &&
                  delivery.systemMessage?.actionText && (
                    <button
                      type="button"
                      className={styles.systemMessageInlineButton}
                      onClick={() =>
                        onAction(delivery.systemMessage?.actionUrl)
                      }
                    >
                      {delivery.systemMessage.actionText}
                    </button>
                  )}
                <div className={styles.messageMeta}>
                  <span className={styles.messageTime}>
                    {formatSystemMessageDate(delivery.createdAt)}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  </div>
);

export default SystemMessageThread;
